import { create } from 'zustand'

import type { WalletCurrency } from '@/domain'
import type { FiatAmount } from '@/types'

interface StoreState {
  triggerShake: boolean
  fiatAmount: FiatAmount
  sharesAmount: number
  selectedCryptoWalletData?: WalletCurrency
  isSellAll: boolean
}

interface StoreFunctions {
  shakeComponent: () => void
  setSelectedCryptoWalletData: (
    selectedCryptoWalletData: WalletCurrency,
  ) => void
  setFiatAmount: (fiatAmount?: FiatAmount) => void
  setSharesAmount: (sharesAmount: number) => void
  resetSellStocksStore: VoidFunction
  setIsSellAll: (isSellAll: boolean) => void
}

export type SellStocksStore = StoreState & StoreFunctions

const initialState: StoreState = {
  triggerShake: false,
  selectedCryptoWalletData: undefined,
  sharesAmount: 0,
  isSellAll: false,
  fiatAmount: {
    amount: '0',
    code: 'USD',
  },
}

export const useSellStocksStore = create<SellStocksStore>()((set) => ({
  ...initialState,
  setFiatAmount: (fiatAmount) => set({ fiatAmount }),
  setSharesAmount: (sharesAmount) => set({ sharesAmount }),
  setSelectedCryptoWalletData: (selectedCryptoWalletData) =>
    set({ selectedCryptoWalletData }),
  setIsSellAll: (isSellAll) => set({ isSellAll }),
  shakeComponent: () => {
    set({ triggerShake: true })
    setTimeout(() => set({ triggerShake: false }), 600)
  },
  resetSellStocksStore: () => set({ ...initialState }),
}))
